import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { IApplicationFormData } from '../../models/application-form-data.model';
import { IUserProfile } from '../../models/user-profile.model';
import { IEnvironment } from '../../models/environment.model';

@Component({
  selector: 'irembogov-application-review',
  templateUrl: './application-review.component.html',
  styleUrls: ['./application-review.component.scss'],
})
export class ApplicationReviewComponent implements OnInit, OnChanges {
  @Input() formData: IApplicationFormData[] | undefined;
  @Input() userProfileData: IUserProfile | undefined;
  @Input() isSubmitting = false;
  @Input() inValidNotification = false;
  @Input() isResubmitting = false;
  @Output() saveEvent = new EventEmitter<IApplicationFormData[]>();
  @Output() editEvent = new EventEmitter<number>();
  @Output() cancelEvent = new EventEmitter();
  @Output() notificationsPreferences = new EventEmitter<
    Record<string, string>
  >();

  notificationForm!: FormGroup;
  emailSelected = false;
  phoneSelected = false;
  displayBlock = false;
  privacyPolicyUrl: string | undefined;
  consent = false;
  userProfile: IUserProfile | undefined;

  constructor(
    private readonly fb: FormBuilder,
    private readonly cdr: ChangeDetectorRef,
    @Inject('environment') private readonly environment: IEnvironment
  ) {
    this.privacyPolicyUrl = this.environment.iremboPrivacyPolicyUrl;
  }

  ngOnInit(): void {
    this.initForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['userProfileData']?.currentValue) {
      if (!this.notificationForm) {
        this.initForm();
      }
      this.userProfileData = changes['userProfileData'].currentValue;
      if (this.userProfileData?.notificationPhoneNumber) {
        this.phoneSelected = true;
        this.notificationForm.get('smsCheckbox')?.setValue(true);
        this.notificationForm
          .get('phone_number')
          ?.setValue(this.userProfileData?.notificationPhoneNumber);
      }

      if (this.userProfileData?.notificationEmail) {
        this.emailSelected = true;
        this.notificationForm.get('emailCheckbox')?.setValue(true);
        this.notificationForm
          .get('email')
          ?.setValue(this.userProfileData?.notificationEmail);
      }
      this.notificationForm.updateValueAndValidity();
      this.notificationForm.markAsTouched();
    }
  }

  initForm() {
    this.notificationForm = this.fb.group({
      smsCheckbox: [false],
      phone_number: [
        this.userProfileData?.notificationPhoneNumber,
        Validators.pattern('^07\\d{8}$'),
      ],
      emailCheckbox: [false],
      email: [this.userProfileData?.notificationEmail, [Validators.email]],
    });

    //Form interactions for notificationss
    this.notificationForm
      .get('smsCheckbox')
      ?.valueChanges.subscribe(checked => {
        const smsInput = this.notificationForm?.get('phone_number');
        this.phoneSelected = checked;
        if (checked) {
          smsInput?.setValidators([
            Validators.required,
            Validators.pattern('^07\\d{8}$'),
          ]);
        } else {
          smsInput?.clearValidators();
          smsInput?.setValue(null);
        }
        smsInput?.updateValueAndValidity();
      });

    this.notificationForm
      .get('emailCheckbox')
      ?.valueChanges.subscribe(checked => {
        const emailInput = this.notificationForm.get('email');
        this.emailSelected = checked;
        if (checked) {
          emailInput?.setValidators([Validators.required, Validators.email]);
        } else {
          emailInput?.clearValidators();
          emailInput?.setValue(null);
        }
        emailInput?.updateValueAndValidity();
      });
  }

  isNotificationValid(): boolean {
    const values = this.notificationForm.value;
    return Object.keys(values).some(
      key => values[key] || this.emailSelected || this.phoneSelected
    );
  }

  onEdit(index: number) {
    this.editEvent.emit(index);
  }

  onCancel() {
    this.cancelEvent.emit();
  }

  onSave() {
    this.notificationsPreferences.emit(this.notificationForm.value);
    this.saveEvent.emit(this.formData);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  trackByFn(index: number, item: IApplicationFormData) {
    return index;
  }
}
